/**
 * Component for links that has a vertical bar (|) or pipe between links with a header
 *
 * @module components/PipedLinks
 */

import PropTypes from 'prop-types';
import React from 'react';

import ButtonT3 from '../../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Theme } from '../../../components/lib/ButtonT3/constants';

import './PipedLinks.scss';

export default class PipedLinks extends React.Component {
  static propTypes = {
    title: PropTypes.node,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.node.isRequired,
        href: PropTypes.string,
        onClick: PropTypes.func,
        qaTag: PropTypes.string,
      }),
    ).isRequired,
  };

  renderLink = ({ label, href, onClick, qaTag }) => {
    return (
      <ButtonT3 theme={ButtonT3Theme.WHITE} href={href} onClick={onClick} qaTag={qaTag}>
        <div className='PipedLinks__link__text'>{label}</div>
      </ButtonT3>
    );
  };

  renderPipedLinksList = () => {
    const { links } = this.props;
    return (
      links && (
        <ul className='PipedLinks__links'>
          {links.map((link, i) => {
            const isNotLastLink = links.length !== i + 1;
            return (
              <li className='PipedLinks__link' key={`pipedLink_${i}`}>
                {this.renderLink(link)}
                {isNotLastLink ? <div className='PipedLinks__pipe' /> : null}
              </li>
            );
          })}
        </ul>
      )
    );
  };

  render() {
    return (
      <div className='PipedLinks'>
        <h4 className='PipedLinks__title'>{this.props.title}</h4>
        {this.renderPipedLinksList()}
      </div>
    );
  }
}
